module.exports = __webpack_public_path__ + "img/1800_YR_2022_Background.b219ad3c.png";